import React, { forwardRef } from 'react';

const IcStatusNeutral = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties,
  ref
}, /* @__PURE__ */ React.createElement("path", {
  d: "M14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
  fill: "var(--color-status-device-neutral)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4.5 8a.8.8 0 0 1 .8-.8h5.4a.8.8 0 0 1 0 1.6H5.3a.8.8 0 0 1-.8-.8Z",
  fill: "#fff"
})));

export { IcStatusNeutral };
//# sourceMappingURL=ic-status-neutral.js.map
